var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalicTextActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2214 5.33689C14.5881 5.45915 14.7863 5.85557 14.6641 6.22233L10.6641 18.2223C10.5418 18.5891 10.1454 18.7873 9.77864 18.665C9.41187 18.5428 9.21366 18.1464 9.33592 17.7796L13.3359 5.77961C13.4582 5.41285 13.8546 5.21464 14.2214 5.33689Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2998 18.0008C6.2998 17.6142 6.61321 17.3008 6.9998 17.3008H12.9998C13.3864 17.3008 13.6998 17.6142 13.6998 18.0008C13.6998 18.3874 13.3864 18.7008 12.9998 18.7008H6.9998C6.61321 18.7008 6.2998 18.3874 6.2998 18.0008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2998 6.00078C10.2998 5.61418 10.6132 5.30078 10.9998 5.30078H16.9998C17.3864 5.30078 17.6998 5.61418 17.6998 6.00078C17.6998 6.38738 17.3864 6.70078 16.9998 6.70078H10.9998C10.6132 6.70078 10.2998 6.38738 10.2998 6.00078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicTextActive);
export default __webpack_public_path__ + "static/media/italic-text-active.032a004b031b05e4d5a5f27da10b9fac.svg";
export { ForwardRef as ReactComponent };